import { AdminMfaRouteDecision, adminMfaRouteDecision, navigateToAdminMfaLogin } from '~/utils/adminMfaRoute';

/**
 * Admin second-factor gate (UX half; the backend refuses every operation but `self`, `logout` and the
 * MFA mutations with MFA_REQUIRED until the session passes a code). A signed-in admin whose session has
 * not passed TOTP is sent to the admin login from any app, including the student and teacher apps an
 * admin with a consumer role would otherwise open onto refused queries.
 */
export default defineNuxtRouteMiddleware(async (to) => {
  const { user } = useAuth();
  if (adminMfaRouteDecision({ path: to.path, status: user.value?.adminMfaStatus }) !== AdminMfaRouteDecision.redirect) {
    return;
  }

  return await navigateToAdminMfaLogin(to.fullPath);
});
